import axios from 'axios';
import React from 'react'
import Swal from 'sweetalert2';
import config from '../../../config';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';

const FUSEAUX = [
    { value: 'Africa/Kinshasa',   label: 'Africa/Kinshasa (UTC+1 — Kinshasa)' },
    { value: 'Africa/Lubumbashi', label: 'Africa/Lubumbashi (UTC+2 — Lubumbashi)' },
    { value: 'Africa/Lagos',      label: 'Africa/Lagos (UTC+1 — Lagos)' },
    { value: 'Africa/Nairobi',    label: 'Africa/Nairobi (UTC+3 — Nairobi)' },
    { value: 'Europe/Paris',      label: 'Europe/Paris (UTC+1/+2)' },
    { value: 'UTC',               label: 'UTC' },
];

const FormEmplacement = ({getUpdataOne,OnchangePut}) => {
    const navigate = useNavigate();

  return (
    <>
        <div className="formCategorie">
            <div className="formCategorie-wrapper">
                <div className="categorie-container-left">
                    <input type="text" name='shop' value={getUpdataOne?.shop || ''} onChange={OnchangePut} placeholder='Nom du shop...' className="categorie-input" />
                    <input type="text" name='adresse' value={getUpdataOne?.adresse || ''} onChange={OnchangePut} placeholder="Adresse..." className="categorie-input" />
                    <input type="number" name='capacite' value={getUpdataOne?.capacite || ''} onChange={OnchangePut} placeholder="Capacité..." className="categorie-input" />
                    <select
                        name='fuseau_horaire'
                        value={getUpdataOne?.fuseau_horaire || 'Africa/Kinshasa'}
                        onChange={OnchangePut}
                        className="categorie-input"
                        style={{ marginTop: 8 }}
                    >
                        {FUSEAUX.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
                    </select>
                </div>
            </div>
        </div>

    </>
  )
}

export default FormEmplacement;
